import { memo } from "react";
import { useTranslate } from "helpers";
import {
  useHandleDateChange,
  useHandleTextFieldChange,
} from "services/forms/hooks";
import { FleetVehicleDamageEditFormValues } from "services/api/fleet/vehicles/damages/types";
import { Errors } from "services/forms/validation/types";
import { TextField } from "ui/components/TextField/TextField";
import { TextArea } from "ui/components/TextField/TextArea";
import { DatePicker } from "ui/components/DatePicker";

interface DamageBasicInfoFormProps {
  formValues: FleetVehicleDamageEditFormValues;
  setFormValues: React.Dispatch<
    React.SetStateAction<FleetVehicleDamageEditFormValues>
  >;
  errors: Errors;
}

const DamageBasicInfoForm: React.FC<DamageBasicInfoFormProps> = ({
  formValues,
  setFormValues,
  errors,
}) => {
  const { t } = useTranslate();

  const handleTextFieldChange = useHandleTextFieldChange(
    setFormValues,
    formValues
  );

  const handleDateChange = useHandleDateChange(setFormValues, formValues);

  return (
    <div className="p-4  h-full flex flex-col">
      <div className="flex flex-col gap-3 flex-1 min-h-0">
        <div className="flex gap-3">
          <div className="flex-1">
            <TextField
              type="text"
              name="name"
              label={t("admin.fleet.damage.add.name")}
              placeholder={t("admin.fleet.damage.add.name.placeholder")}
              onChange={handleTextFieldChange}
              error={errors.name}
              value={formValues.name}
              required
            />
          </div>
          <div className="flex-1">
            <DatePicker
              name="damageDate"
              label={t("admin.fleet.damage.add.damagedate")}
              placeholder={t(
                "admin.fleet.damage.add.damagedate.placeholder"
              )}
              onChange={handleDateChange}
              error={errors.damageDate}
              value={formValues.damageDate}
              width="full"
              required
            />
          </div>
        </div>
        <div className="flex-1 min-h-0 flex flex-col">
          <TextArea
            name="description"
            label={t("admin.fleet.damage.add.description")}
            placeholder={t(
              "admin.fleet.damage.add.description.placeholder"
            )}
            onChange={handleTextFieldChange}
            error={errors.description}
            value={formValues.description}
            cssClassName="flex-1"
            rows={10}
          />
        </div>
      </div>
    </div>
  );
};

export default memo(DamageBasicInfoForm);
